<template>
  <svg
    :width="width"
    :height="height"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 164 164"
  >

<title xmlns="http://www.w3.org/2000/svg">product-icons/chat</title>
<desc xmlns="http://www.w3.org/2000/svg">Created with Sketch.</desc>
<g xmlns="http://www.w3.org/2000/svg" id="Page-1">
	<g id="gdpr-products" transform="translate(-830.000000, -2279.000000)">
		<g id="Product-Icons_x2F_Chat" transform="translate(830.000000, 2279.000000)">
			<g id="chat">
				<g id="Group-14" transform="translate(45.000000, 30.000000)">
					<path id="Fill-2" d="M26,8.1c0,0,0.1,0,0.1,0.1c14.2,14.2,14.1,37.1,0,51.2L0.5,33.6L26,8.1z" style="fill:#F79A3E;"/>
					<path id="Fill-4" class="st1" d="M55.3,37.4c0,0,0-0.1-0.1-0.1c-10.1-10.1-10.1-26.4,0-36.5l18.3,18.3L55.3,37.4z" style="fill:#00363D;"/>
					<path id="Fill-6" class="st1" d="M10.1,95.4c0-3.9,3-6.9,6.9-6.9c2.9,0,5.3,1.7,6.3,4.1l-2.5,1.1c-0.7-1.5-2-2.5-3.7-2.5       c-2.4,0-4.1,1.9-4.1,4.2c0,2.3,1.8,4.2,4.2,4.2c1.8,0,3.1-1.1,3.7-2.6l2.6,1.1c-1.1,2.4-3.3,4.2-6.4,4.2       C13.1,102.3,10.1,99.3,10.1,95.4" style="fill:#00363D;"/>
					<path id="Fill-8" class="st1" d="M25.5,82.7h2.8v7.8c0.9-1.2,2.4-1.9,4.1-1.9c3.3,0,5.4,2.2,5.4,5.8v7.7h-2.9v-7.5       c0-2.2-1.1-3.6-3.2-3.6c-1.9,0-3.3,1.4-3.3,3.8v7.3h-2.8V82.7z" style="fill:#00363D;"/>
					<path id="Fill-10" class="st1" d="M51.1,95.4c0-2.4-1.8-4.3-4.2-4.3c-2.4,0-4.2,1.9-4.2,4.3c0,2.4,1.8,4.3,4.2,4.3       C49.4,99.7,51.1,97.8,51.1,95.4 M40,95.4c0-4.2,3.2-6.9,6.6-6.9c1.7,0,3.4,0.8,4.4,2v-1.7h2.8v13.2H51v-1.8       c-1,1.3-2.7,2.1-4.4,2.1C43.2,102.3,40,99.6,40,95.4" style="fill:#00363D;"/>
					<path id="Fill-12" class="st1" d="M56,88.8h2.3v-3.1l2.9-1.6v4.7h2.8v2.5h-2.8v5.3c0,2.4,0.4,2.8,2.8,2.8v2.7h-0.4       c-4,0-5.2-1.3-5.2-5.4v-5.3H56V88.8z" style="fill:#00363D;"/>
				</g>
			</g>
		</g>
	</g>
</g>

  </svg>
</template>

<script>
import VueTypes from 'vue-types';
export default {
  name: 'FacebookLogoIcon',
  props: {
    height: VueTypes.string.def('32'),
    width: VueTypes.string.def('32'),
  },
};
</script>

<style lang="scss"></style>
